var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ef01feff-0e70-45d9-b4b8-77f989b038aa",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 606.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-dfdad5a6-92ee-4825-8f6e-d38fe6e714d8",
    d: "M450.07,516.41h-147.04c-117.6,0-213.29-95.69-213.29-213.29s95.69-213.38,213.29-213.38h148.4c24.76,0,44.87-20.07,44.87-44.87S476.18,0,451.43,0h-148.4C135.91,0,0,136,0,303.11s135.91,303.03,303.03,303.03h147.04c24.8,0,44.87-20.07,44.87-44.87s-20.07-44.87-44.87-44.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-dfdad5a6-92ee-4825-8f6e-d38fe6e714d8",
    d: "M776.97,0h-147.09c-24.76,0-44.87,20.07-44.87,44.87s20.11,44.87,44.87,44.87h147.09c117.6,0,213.29,95.69,213.29,213.38s-95.69,213.29-213.29,213.29h-148.4c-24.8,0-44.87,20.07-44.87,44.87s20.07,44.87,44.87,44.87h148.4c167.07,0,303.03-135.91,303.03-303.03S944.04,0,776.97,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-dfdad5a6-92ee-4825-8f6e-d38fe6e714d8",
    d: "M279.23,303.11c0,24.8,20.11,44.87,44.87,44.87h430.66c24.8,0,44.87-20.07,44.87-44.87s-20.07-44.87-44.87-44.87h-430.66c-24.76,0-44.87,20.07-44.87,44.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.db22e4322204158eb1ef3e2e90b1e116.svg";
export { ForwardRef as ReactComponent };